module.exports = __webpack_public_path__ + "static/media/logo_white.3a22c9dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_white.svg
// module id = 195
// module chunks = 36